import { Globals } from '@mabinso-registry/module-commons';

export default Globals;
